<template>
  <div class="falecidoPassoBox">
    <h4 class="headerTitle mb-2">
      Falecido
    </h4>
    <form class="px-2"
          name="formDadosFalecido"
          novalidate>
      <!-- Primeira linha do formulário -->
      <div class="row no-gutters">
        <div class="form-group">
          <span class="custom-control custom-switch mr-4">
            <input id="pessoaDescon"
                   ref="pessoaDescon"
                   v-model="localData.pessoa_desconhecida"
                   class="custom-control-input"
                   name="pessoaDescon"
                   type="checkbox"
                   value="O"
                   :disabled="localData.natimorto"
                   @change="definirTipoRegistroObito"
                   @keydown.enter="changeDesconhecido()">
            <label class="custom-control-label"
                   for="pessoaDescon">Pessoa desconhecida</label>
          </span>
        </div>
        <div class="form-group">
          <span class="custom-control custom-switch">
            <input id="natimorto"
                   ref="natimorto"
                   v-model="localData.natimorto"
                   class="custom-control-input"
                   name="natimorto"
                   type="checkbox"
                   value="NT"
                   :disabled="localData.pessoa_desconhecida ||
                     (localData.registro.tipo_registro === 'NT' && localData.registro.livro && localData.registro.livro.tipo_livro === 'NT') ||
                     (localData.registro.tipo_registro === 'O' && localData.registro.livro && localData.registro.livro.tipo_livro === 'O')"
                   @change="definirTipoRegistroNT"
                   @keyup.enter="changeNatimorto()">
            <label class="custom-control-label"
                   for="natimorto">Natimorto</label>
          </span>
        </div>
      </div>

      <!-- CPF, sem inscrição -->
      <div class="row">
        <div class="col-sm-4 col-lg-4">
          <div class="form-group">
            <label class="label"
                   :class="{'label-error': error_cpf}"
                   for="cpf">CPF
            </label>
            <IconSvg v-if="error_cpf"
                     class="icon-error-campo"
                     icon="alert" />
            <input id="cpf"
                   ref="falecido_cpf"
                   v-model="localData.cpf"
                   v-mask="`999.999.999-99`"
                   v-validate="{ required: !localData.cpf_sem_inscricao, regex: /\d{3}\.\d{3}\.\d{3}-\d{2}$/ }"
                   :class="{ 'is-invalid': errors.has('cpf') || error_cpf }"
                   class="form-control form-control-sm"
                   name="cpf"
                   placeholder="000.000.000-00"
                   type="tel"
                   :disabled="!!localData.pessoa_desconhecida || !!localData.natimorto || !!localData.cpf_sem_inscricao"
                   @input="checkCPF()">
            <small v-if="errors.has('cpf')"
                   class="invalid-feedback">{{ errors.first('cpf') }}</small>
          </div>
        </div>

        <div class="col-sm-4 col-lg-4">
          <div class="form-group">
            <label class="mb-4"
                   for="cpf_sem_inscricao" />
            <span class="custom-control custom-switch">
              <input id="cpf_sem_inscricao"
                     v-model="localData.cpf_sem_inscricao"
                     class="custom-control-input"
                     name="cpf_sem_inscricao"
                     type="checkbox"
                     :value="1"
                     :disabled="localData.pessoa_desconhecida || localData.natimorto"
                     @change="[localData.cpf = null, changed()]"
                     @keyup.enter="changeSemCPF()">
              <label class="custom-control-label"
                     for="cpf_sem_inscricao">Sem inscrição</label>
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-lg-12">
          <div class="form-group">
            <label class="label"
                   :class="{'label-error': error_nome}"
                   for="nome">Nome
              <IconSvg v-if="error_nome"
                       class="icon-error-campo"
                       icon="alert" />
            </label>
            <input id="nome"
                   v-model.lazy="localData.nome"
                   v-uppercase
                   v-validate="!localData.natimorto ? `required` : ''"
                   :class="{ 'is-invalid': errors.has('nome') || error_nome}"
                   class="form-control form-control-sm text-uppercase"
                   name="nome"
                   placeholder="Valentina Alves Silva"
                   type="text"
                   @change="validateInputs('nome')">
            <small v-if="errors.has('nome')"
                   class="invalid-feedback">{{ errors.first('nome') }}</small>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-lg-4">
          <div class="form-group">
            <label class="label"
                   for="data_nascimento">Data de nascimento</label>
            <input id="data_nascimento"
                   v-model="localData.data_nascimento"
                   v-mask="`##/##/####`"
                   v-validate="`date_format:dd/MM/yyyy|date_between:01/01/1500,${limitDate}|max_date:${new Date()}`"
                   :class="{ 'is-invalid': errors.has('data_nascimento')}"
                   class="form-control form-control-sm"
                   name="data_nascimento"
                   placeholder="00/00/0000"
                   type="tel"
                   :disabled="localData.pessoa_desconhecida || localData.natimorto || !!localData.nascimento_sem_data"
                   @input="changeIdade">
            <small v-if="errors.has('data_nascimento')"
                   class="invalid-feedback">{{ errors.first('data_nascimento') }}</small>
          </div>
        </div>

        <div class="col-sm-4 col-lg-4">
          <div class="form-group">
            <label class="mb-4"
                   for="nascimento_sem_data" />
            <span class="custom-control custom-switch">
              <input id="nascimento_sem_data"
                     v-model="localData.nascimento_sem_data"
                     class="custom-control-input"
                     name="nascimento_sem_data"
                     type="checkbox"
                     :value="1"
                     :disabled="localData.pessoa_desconhecida || localData.natimorto"
                     @change="changeSemNascimento()"
                     @keyup.enter="changeSemNascimento">
              <label class="custom-control-label"
                     for="nascimento_sem_data">Sem data informada</label>
            </span>
          </div>
        </div>

        <div v-if="!localData.nascimento_sem_data"
             class="col-sm-4 col-lg-4">
          <div class="form-group">
            <label class="label"
                   for="idade">Idade</label>
            <p class="mt-1">
              <span v-if="errors.has('data_nascimento')"
                    class="text-danger">Data inválida</span>
              <span v-else
                    class="label">
                {{ idade_tipo }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 col-lg-4">
          <div class="form-group">
            <label class="label"
                   :class="{'label-error': error_sexo}"
                   for="sexo">Sexo</label>
            <IconSvg v-if="error_sexo"
                     class="icon-error-campo"
                     icon="alert" />
            <select id="sexo"
                    v-model="localData.sexo"
                    class="custom-select custom-select-sm"
                    :class="{'is-invalid': error_sexo}"
                    name="sexo"
                    @change="changed">
              <option value=""
                      selected>
                Selecione
              </option>
              <option v-for="(sexo, ind) in SEXOS"
                      :key="ind"
                      :value="sexo.value">
                {{ sexo.name }}
              </option>
            </select>
            <small v-if="errors.has('sexo')"
                   class="invalid-feedback">{{ errors.first('sexo') }}</small>
          </div>
        </div>
        <div class="col-sm-4 col-lg-4">
          <div class="form-group">
            <label class="label"
                   :class="{'label-error': error_cor_pele}"
                   for="cor_pele">Cor de pele</label>
            <IconSvg v-if="error_cor_pele"
                     class="icon-error-campo"
                     icon="alert" />
            <select id="cor_pele"
                    v-model="localData.cor_pele"
                    class="custom-select custom-select-sm"
                    :class="{'is-invalid': error_cor_pele}"
                    name="cor_pele"
                    @change="changed">
              <option value=""
                      selected>
                Selecione
              </option>
              <option v-for="(cor, ind) in CORES_PELE"
                      :key="ind"
                      :value="cor.value">
                {{ cor.name }}
              </option>
            </select>
            <small v-if="errors.has('cor_pele')"
                   class="invalid-feedback">{{ errors.first('cor_pele') }}</small>
          </div>
        </div>

        <div class="col-sm-4 col-lg-4">
          <div class="form-group">
            <label class="label"
                   for="estado_civil">Estado Civil</label>
            <select id="estado_civil"
                    v-model="localData.estado_civil"
                    class="custom-select custom-select-sm"
                    :disabled="localData.pessoa_desconhecida"
                    name="estado_civil"
                    @change="changed">
              <option v-for="(estado, ind) in ESTADOS_CIVIL.filter(est => (localData.sexo && localData.sexo !='I' )? est.genero == localData.sexo : est.value )"
                      :key="ind"
                      :value="estado.value">
                {{ estado.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <label class="label"
                   for="nacionalidade">Nacionalidade</label>
            <Nacionalidades id="nacionalidade"
                            v-model="localData.nacionalidade_codigo"
                            :prop-nacionalidade="localData.nacionalidade"
                            :prop-sexo="localData.sexo"
                            @updated="nacionalidadeChanged" />
          </div>
        </div>

        <div class="col-4"
             :class="{'d-none': localData.nacionalidade && localData.nacionalidade.codigo != 76}">
          <div class="form-group">
            <label class="label"
                   for="uf">UF</label>
            <v-select :id="`uf-${_uid}`"
                      v-model="localData.uf"
                      class="form-control form-control-sm"
                      name="ufFalecido"
                      placeholder="Selecione"
                      :options="selectsOptions.states.map((state)=>state.uf)"
                      @input="ufChanged" />
          </div>
        </div>
        <div v-if="show_naturalidade"
             class="col-4">
          <div class="form-group">
            <label class="label"
                   for="naturalidade">Naturalidade</label>
            <v-select :id="`naturalidade-${_uid}`"
                      v-model="naturalidade"
                      class="form-control form-control-sm"
                      name="naturalidadeFalecido"
                      placeholder="Selecione"
                      :taggable="localData.uf !== 'EX'"
                      :options="citiesFiltered.map((city)=>city.nome)"
                      @input="naturalidadeChanged" />
          </div>
        </div>
        <div v-if="showNatDeclarada"
             class="col-4 col-sm-6">
          <div class="form-group">
            <label class="label"
                   for="naturalidade_declarada">Naturalidade declarada pelo cidadão</label>
            <input id="naturalidade_declarada"
                   v-model="localData.naturalidade_declarada"
                   class="form-control form-control-sm"
                   name="naturalidade_declarada"
                   type="text"
                   :disabled="localData.pessoa_desconhecida"
                   @change="changed">
          </div>
        </div>
      </div>
    </form>

    <EnderecoFalecido :prop-endereco="localData.endereco || {}"
                      :prop-cartorio="propCartorio"
                      :prop-disabled="!!localData.pessoa_desconhecida || !!localData.natimorto"
                      @addAddress="getAddress"
                      @deleteAddress="deleteAddress" />


    <Genitores
      v-if="!localData.pessoa_desconhecida"
      :read-only="readOnly"
      :genitores="localData.genitores"
      :endereco-registrado="localData.endereco"
      :pessoa-id="localData.pessoa_id"
      :prop-cartorio="propCartorio"
      :prop-validate="true"
      :prop-correcoes="propCorrecoes"
      :prop-tipo-registro="localData.registro.tipo_registro"
      :prop-data="{ registro: { pessoa: { data_nascimento: localData.data_nascimento } } }"
      @genitorAdded="getGenitores"
      @genitorRemoved="removeGenitor"
      @genitorUpdated="updateGenitor"
      @removeEndereco="removeEnderecoGenitor"
      @removeDocumento="removeDocumento"
      @deleteError="deleteError" />
  </div>
</template>

<script>


/* components */
  import Genitores from '../Passos/Sessoes/Genitores.vue'
  import Nacionalidades from "@/components/SofiaRei/Nacionalidades"
  import EnderecoFalecido from "../Passos/Sessoes/EnderecoFalecido"

  /* services */
  import PessoasService from "@/services/Pessoas"

  /* constants */
  import { ESTADOS_CIVIL } from "@/constants/estadosCivil"
  import SEXOS from "@/constants/sexos"
  import TIPOS_IDADE from "@/constants/tiposIdade"
  import CORES_PELE from "@/constants/coresPele"
  import BrazilianStates from "@/constants/brazilianStates"
  import Cidades from "@/constants/repositorio/cidades.json"


  const constantes = { DESCONHECIDO_NATIMORTO, DESCONHECIDO, NATIMORTO, SEXOS, TIPOS_IDADE, ESTADOS_CIVIL, CORES_PELE }
  const DESCONHECIDO_NATIMORTO = "pessoa_desconhecida_natimorto"
  const DESCONHECIDO = "pessoa_desconhecida"
  const NATIMORTO = "natimorto"

  /* filters */
  import { filterDate, filterMaskedNumber } from '@/filters/filters'

  /* outros */
  import moment from "moment"

  export default {
    name: 'PassoFalecido',
    components: { Genitores, Nacionalidades, EnderecoFalecido },
    inject: ['$validator'],
    props: {
      data: { type: Object, default: () => { return {} } },
      readOnly: { type: Boolean, default: ()=> false},
      propCartorio: { type: Object, default: () => { return {} } },
      propCorrecoes: {type: Object, default: () => ({})}
    },
    data () {
      return {
        ...constantes,
        primeiro_passo_valido: false,
        registroId: this.data.registro.registro_id || null,
        profissaoPreload: '',
        disable_cpf: false,
        show_naturalidade: true,
        naturalidade: "",
        localData: {
          natimorto: false,
          codigo_ocupacao: [],
          cpf_sem_inscricao: false,
          pessoa_desconhecida: false,
          naturalidade: this.data.naturalidade,
          nacionalidade_codigo: 76,
          estado_civil: 'IGNORADO',
          idade_tipo: null,
          sexo: '',
          endereco: {},
          genitores: [],
          nascimento_sem_data: false,
          registro: this.data.registro
        },
        cpfNumber: '',
        desconhecidoDisabled: false,
        natimortoDisabled: false,
        desconhecidoNatimortoDisabled: false,
        deleteds: { genitores: [], anteriores: [], enderecos: [] },
        selectsOptions: { states: [...BrazilianStates], cities: [], nacionalidades: [] },
        citiesFiltered: [],
        idade_tipo: "Informe a data de nascimento",
        correcoes: {...this.propCorrecoes},
        error_cpf: false,
        error_nome: false,
        error_sexo: false,
        error_cor_pele: false,
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY')
      }
    },
    computed: {
      showNatDeclarada () {
        let { nacionalidade_codigo } = this.localData

        if (nacionalidade_codigo && nacionalidade_codigo != 76) {
          return true
        }

        return (this.naturalidade === 'Outro')
      }
    },
    watch: {
      async data () {
        if (!this.data.nacionalidade_codigo) {
          delete this.data.nacionalidade_codigo
        }

        Object.assign(this.localData, this.data)

        if (!!this.localData.naturalidade) {
          this.naturalidade = this.localData.naturalidade
        }
        this.selectsOptions.cities = Cidades
        this.selectsOptions.cities.push({nome: 'Outro'})

        if (this.localData.uf) {
          this.filterCities()
        }

        this.localData.registro = this.data.registro

        this.registroId = this.data.registro.registro_id || null

        if (this.localData.nacionalidade_codigo != 76) {
          this.show_naturalidade = false
        }
      },
      propCartorio () {
        this.init()
      },
      propCorrecoes () {
        this.verifyErrorsCarga()
      },
      'data.registro.data_ocorrido': function () {
        this.changeIdade()
      }
    },
    async beforeMount () {
      this.selectsOptions.cities = Cidades
      this.selectsOptions.cities.push({nome: 'Outro'})

      if (this.localData.uf) {
        this.filterCities()
      }
    },
    created () {
      if (!this.data.nacionalidade_codigo) {
        delete this.data.nacionalidade_codigo
      }

      Object.assign(this.localData, this.data)

      if (!!this.localData.naturalidade) {
        this.naturalidade = this.localData.naturalidade
        this.naturalidadeChanged()
      }

      if (this.localData.uf) {
        this.filterCities()
      }

      if (this.localData.nacionalidade_codigo != 76) {
        this.show_naturalidade = false
      }

      if (this.localData.cpf) {
        const cpfNumber = this.localData.cpf.replace(/[^\d]/g, "")
        this.localData.cpf = cpfNumber.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
        this.changed()
      }

      if (this.localData.data_nascimento) {
        this.localData.data_nascimento = this.localData.data_nascimento.replaceAll('-', '/')
        this.changed()
      }
    },
    mounted () {
      this.$refs[this.localData.natimorto ? "natimorto" : "pessoaDescon"].focus()

      setTimeout(() => {
        this.changed()
      }, 200)

      this.verifyErrorsCarga()
    },
    methods: {
      init () {
        if (this.propCartorio) {
          if (Object.keys(this.propCartorio).length > 0) {
            if (this.propCartorio.endereco && !this.localData.nome) {
              this.localData.uf = this.propCartorio.endereco.uf
              this.naturalidade = this.propCartorio.endereco.cidade

              this.naturalidadeChanged()
            }
          }
        }
      },
      async checkCPF () {
        let cpf = filterMaskedNumber(this.localData.cpf)

        if (cpf && cpf.length < 11) return

        this.deleteError(['CPF DO FALECIDO', 'CPF DO REGISTRADO'])

        try {
          const busca = await PessoasService.getCadastroByCPF(cpf)

          const [pessoa] = busca.data

          if (pessoa &&  pessoa.obito && pessoa.obito.obito_id != this.$route.params.id) {
            objSwal.error.title = "CPF já cadastrado!"
            objSwal.error.text = "Este CPF já possui um registro de óbito, você será redirecinado para o registro."

            return Swal.fire(objSwal.error).then(() => {
              this.$router.push({ name: 'resumo_obito', params: { id: pessoa.obito.obito_id }})
            })
          } else {

            const dados = await PessoasService.getPessoaByCPF(cpf)

            if (dados.isEmpty) {
              this.changed()
              return
            }

            const { nome, datanascimento, sexo, nomemae } = dados
            const sexos = {
              1: 'M',
              2: 'F'
            }

            if (nomemae) {
              // deixando sexo feminino temporário para se adaptar ao que vem da CRC
              const mother = this.localData.genitores.find(genitor => genitor.pessoa.nome == nomemae)
              if (!mother) {
                this.localData.genitores = []
                this.localData.genitores.push({ pessoa: { nome: nomemae, sexo: "F" } })
              }
            }

            this.localData.nome = nome
            this.localData.data_nascimento = filterDate(datanascimento)

            this.changeIdade()

            this.localData.sexo = sexos[sexo] || 'I'
          }
        } catch (error) {
          objSwal.error.title = 'Erro ao buscar CPF!'
          objSwal.error.text = error.message
          this.changed()
          return Swal.fire(objSwal.error)
        }
      },
      removeDocumento (documento) {
        this.$emit('removeDocumento', documento)
      },
      definirTipoRegistroNT () {
        this.localData.tipo_registro_obito = 'NT'

        if (this.localData.natimorto) {
          this.localData.nome = 'SEM DESIGNAÇÃO DO NOME'
          this.localData.data_nascimento = null
          this.localData.idade = null
          this.localData.idade_tipo = null
          this.localData.cpf = null
          this.localData.cpf_sem_inscricao = true
          this.localData.ocupacao_declarada = null
          this.localData.ocupacao_codigo = null
        }

        this.changed()
      },
      definirTipoRegistroObito () {
        this.localData.tipo_registro_obito = 'O'

        if (this.localData.pessoa_desconhecida) {
          this.localData.nome = 'DESCONHECIDO'
          this.localData.data_nascimento = null
          this.localData.idade = ''
          this.localData.idade_tipo = null
          this.localData.cpf = null
          this.localData.cpf_sem_inscricao = true
          this.localData.uf = ''
          this.localData.ocupacao_declarada = ''
          this.localData.ocupacao_codigo = null
          this.localData.naturalidade = ''
          this.naturalidade = ''
          this.localData.estado_civil = 'IGNORADO'
        } else {
          this.localData.nome = ''
        }

        this.changed()
      },
      naturalidadeChanged () {
        this.localData.naturalidade = this.naturalidade

        if (this.localData.registro.pessoa) {
          this.localData.registro.pessoa.naturalidade = this.naturalidade
        } else {
          this.localData.registro = {
            ...this.localData.registro,
            pessoa: {
              naturalidade: this.naturalidade
            }
          }
        }

        this.changed()
      },
      ufChanged () {
        this.naturalidade = ''
        this.changed()

        this.filterCities()

        this.verifyReset()
      },
      nacionalidadeChanged (nacionalidade) {
        this.localData.nacionalidade = nacionalidade
        if (this.localData.nacionalidade.nome === "Brazil" || this.localData.nacionalidade.nome === "Brasil") {
          this.localData.uf = ""
          this.show_naturalidade = true
          this.localData.naturalidade_declarada =  null
        } else {
          this.show_naturalidade = false
          this.localData.uf = "EX"
        }
        this.changed()
      },
      getAddress (endereco) {
        this.localData.endereco = endereco
        this.changed()
      },
      async cpfDuplicate (pessoa, index = null) {
        if (!pessoa.cpf) return true

        // Tiramos a mascara no cpf
        pessoa.cpf = await filterMaskedNumber(pessoa.cpf)

        // Verificamos o falecido
        this.localData.cpf = await filterMaskedNumber(this.localData.cpf)
        const falecidoComMesmoCPF = this.localData.cpf ? this.localData.cpf === pessoa.cpf : false

        if (!this.localData.genitores.length && !falecidoComMesmoCPF) return true

        // Verificamos os gentitores
        const pessoaComMesmoCPF = this.localData.genitores.find(genitor => genitor.pessoa.cpf === pessoa.cpf)

        if (!pessoaComMesmoCPF && !falecidoComMesmoCPF) return true

        if (typeof index === 'number' && index >= 0) {
          const indexPessoaComMesmoCPF = this.localData.genitores.findIndex(genitor => genitor.pessoa.cpf === pessoa.cpf)

          if (indexPessoaComMesmoCPF === index && !falecidoComMesmoCPF) return true
        }

        objSwal.error.title = `Erro ao ${index && index >= 0 ? 'atualizar' : 'cadastrar'} genitor ${pessoa.nome}`
        objSwal.error.text = `CPF já cadastrado para o ${falecidoComMesmoCPF ? 'falecido(a)' : 'genitor(a)'} ${falecidoComMesmoCPF ? this.localData.nome : pessoaComMesmoCPF.pessoa.nome}`
        objSwal.error.html = ''

        Swal.fire(objSwal.error)

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)
      },
      async getGenitores (genitor) {
        const cpfValid = await this.cpfDuplicate(genitor.pessoa)

        if (cpfValid) {
          this.localData.genitores.push(genitor)
          this.changed()

          objSwal.success.title = "Adicionado com Sucesso"
          objSwal.success.text = ''
          objSwal.success.html = ''

          Swal.fire(objSwal.success).then(() => {
            const btn_add = document.querySelector('.btn-add-genitor')

            if (btn_add) btn_add.focus()
          })

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 300)
        }
      },
      async updateGenitor (genitor, genitorIndex) {
        const cpfValid = await this.cpfDuplicate(genitor.pessoa, genitorIndex)

        if (cpfValid) {
          this.localData.genitores[genitorIndex] = genitor
          this.localData.genitores = [ ...this.localData.genitores ]

          this.changed()

          objSwal.success.title = "Atualizado com Sucesso"
          objSwal.success.text = ''
          objSwal.success.html = ''

          Swal.fire(objSwal.success).then(() => {
            const btn_add = document.querySelector('.btn-add-genitor')

            if (btn_add) btn_add.focus()
          })

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 300)
        }
      },
      removeGenitor (localId) {
        const deleted = this.localData.genitores[localId]

        if (!deleted) return

        this.localData.genitores.splice(localId, 1)

        this.$emit("genitorRemoved", deleted)

        this.changed()
      },
      changeIdade () {
        if (!this.localData.data_nascimento) {
          this.localData = {
            ...this.localData,
            idade: null,
            idade_tipo: null,
            nascimento_sem_data: false
          }

          return this.changed()
        }
        const dataNascimento = moment(this.localData.data_nascimento, 'DD/MM/YYYY')

        let dataComparacao = moment()

        if (this.localData.registro.data_ocorrido) {
          dataComparacao = moment(this.localData.registro.data_ocorrido)
        }

        const diferenciaEmDias = moment(dataComparacao).diff(dataNascimento, 'days')
        const diferenciaEmMeses = moment(dataComparacao).diff(dataNascimento, 'months')
        const diferenciaEmAnos = moment(dataComparacao).diff(dataNascimento, 'years')

        // fazemos todas as validações em dias, pois dependendo o mês e ano o resultado do moment() não sai preciso
        if (diferenciaEmDias < 30 || diferenciaEmMeses < 1) {
          return this.updateIdade(diferenciaEmDias, 'D', `${diferenciaEmDias} ${diferenciaEmDias <= 1 ? 'dia' : 'dias'}`)
        }

        if (diferenciaEmMeses >= 1 && diferenciaEmMeses < 12) {
          return this.updateIdade(diferenciaEmMeses, 'M', `${diferenciaEmMeses} ${diferenciaEmMeses === 1 ? 'mês' : 'meses'}`)
        }

        if (diferenciaEmAnos >= 1) {
          return this.updateIdade(diferenciaEmAnos, 'A', `${diferenciaEmAnos} ${diferenciaEmAnos === 1 ? 'ano' : 'anos'}`)
        }
      },
      updateIdade (idade, tipoIdadeToLocalData, tipoIdadeToData) {
        this.localData = {
          ...this.localData,
          idade: idade,
          idade_tipo: tipoIdadeToLocalData
        }

        this.idade_tipo = tipoIdadeToData

        this.changed()
      },
      changed (event) {
        if (event) {
          if (event.target.name == "sexo") this.deleteError(['SEXO DO FALECIDO'])
          else if (event.target.name == "cor_pele") this.deleteError(['COR DA PELE'])
        }

        if (!this.localData.pessoa_id) {
          this.create()
        } else {
          this.updated()
        }
      },
      async create () {
        this.$emit('changed', { ...this.localData }, 0)
      },
      async updated () {
        this.$emit('updatedPessoa', {
          cpf: this.localData.cpf,
          cpf_sem_inscricao: this.localData.cpf_sem_inscricao,
          nome: this.localData.nome,
          data_nascimento: this.localData.data_nascimento ? moment(String(this.localData.data_nascimento), 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
          sexo: this.localData.sexo,
          cor_pele: this.localData.cor_pele,
          nacionalidade: this.localData.nacionalidade,
          nacionalidade_codigo: this.localData.nacionalidade_codigo,
          estado_civil: this.localData.estado_civil,
          ocupacao_codigo: this.localData.ocupacao_codigo,
          ocupacao_declarada: this.localData.ocupacao_declarada,
          naturalidade: this.naturalidade,
          naturalidade_declarada: this.localData.naturalidade_declarada,
          uf: this.localData.uf,
          idade: this.localData.idade,
          idade_tipo: this.localData.idade_tipo,
          pessoa_desconhecida: this.localData.pessoa_desconhecida,
          natimorto: this.localData.natimorto,
          endereco: this.localData.endereco
        })
      },
      upperName () {
        if (this.localData.nome) {
          this.localData.nome = this.localData.nome.toUpperCase()
        }
      },
      validateInputs (name) {
        if (name == 'nome') this.deleteError(['NOME DO FALECIDO', 'NOME DO REGISTRADO'])
        this.upperName()
        this.$validator.validate(name)
        this.changed()
      },
      updateLocalData (propertyName = null, value = "") {
        if (typeof(propertyName) === 'string' && propertyName.length > 0) {
          if (propertyName in this.localData) {
            this.localData[propertyName] = value
            this.changed()
          }
        }
      },
      updateProfissao (profissao) {
        this.localData.ocupacao = profissao
        this.localData.ocupacao_codigo = profissao.codigo

        this.changed()
      },
      deleteAddress (endereco) {
        if (endereco.endereco_id) {
          this.$emit('deleteAddress', endereco)
          this.deleteds.enderecos.push(endereco.endereco_id)
        }
        this.changed()
      },
      updateAdresses (enderecos) {
        this.localData.enderecos = enderecos
        this.changed()
      },
      removeEnderecoGenitor (endereco) {
        if (endereco.endereco_id) {
          this.deleteds.enderecos.push(endereco.endereco_id)
          this.$emit('deleteAddress', endereco)
        }
      },
      filterCities () {
        if (!this.selectsOptions && !this.selectsOptions.cities) return []

        if (this.localData.uf) {
          const state = this.selectsOptions.states.find(state => state.name === this.localData.uf)

          /**
           * Fazemos essa verificação pois na migração alguns registros não
           * trazem a UF em sigla e sim com o nome completo
           */
          if (state) {
            this.localData.uf = state.uf
          }

          const stateSelected = this.selectsOptions.states.find(state => state.uf == this.localData.uf)

          if (stateSelected.uf !== 'EX') {
            this.citiesFiltered = this.selectsOptions.cities.filter(city => city.codigo_uf == stateSelected.ibgeId)
          } else {
            this.citiesFiltered = [{nome: 'Outro'}]
            this.naturalidade = 'Outro'
          }
        }
      },
      verifyReset () {
        if (this.localData.naturalidade) {
          const cidade =  this.citiesFiltered.filter((city) => city.nome == this.localData.naturalidade)

          if (!cidade.length) {
            this.naturalidade = ""
            this.naturalidadeChanged()
          }
        }
      },
      deleteError (error) {
        this.$emit('deleteError', error)
      },
      verifyErrorsCarga () {
        this.error_cpf = false
        this.error_nome = false
        this.error_sexo = false
        this.error_cor_pele = false

        Object.keys(this.propCorrecoes).forEach(key => {
          if (['CPF DO FALECIDO', 'CPF DO REGISTRADO'].indexOf(key) != -1) this.error_cpf = true

          if (['NOME DO FALECIDO', 'NOME DO REGISTRADO'].indexOf(key) != -1) this.error_nome = true

          if (['SEXO DO FALECIDO', 'SEXO DO REGISTRADO'].indexOf(key) != -1) this.error_sexo = true

          if (['COR DA PELE'].indexOf(key) != -1) this.error_cor_pele = true
        })
      },
      changeDesconhecido () {
        this.localData.pessoa_desconhecida = !this.localData.pessoa_desconhecida

        this.definirTipoRegistroObito()
      },
      changeNatimorto () {
        this.localData.natimorto = !this.localData.natimorto

        this.definirTipoRegistroNT()
      },
      changeSemCPF () {
        this.localData.cpf_sem_inscricao = !this.localData.cpf_sem_inscricao

        this.localData.cpf = null

        this.changed()
      },
      changeSemNascimento () {
        this.localData.data_nascimento = null

        if (this.localData.nascimento_sem_data) {
          this.idade_tipo = null
          this.localData.idade_tipo = null

        } else {
          this.idade_tipo = "Informe a data de nascimento"
        }


        this.changed()
      },
      displaySuccess (title, text, html) {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = html

        return Swal.fire(objSwal.success).then((res) => {
          objSwal.success.title = ''
          objSwal.success.text = ''
          objSwal.success.html = ''

          return res
        })
      },
      displayError (title, text, html) {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = html

        return Swal.fire(objSwal.error).then((res) => {
          objSwal.error.title = ''
          objSwal.error.text = ''
          objSwal.error.html = ''

          return res
        })
      },
    },
  }
</script>

<style lang="scss">
@import '../../../../scss/_utilities/exports';

.falecidoPassoBox {}

.icon-error-campo {
  width: 15px;
  height: 15px;
  margin: 0;
  padding: 0;
  fill: #8B0000;
}

.label-error {
  color: #8B0000;
}

.headerTitle {
  @extend %titleBox--sm;
  background-color: $color-gray-light;
}
</style>
